<ng-container *transloco="let t">
  <app-holidays-dates-form [submitButtonText]="t('settings/addDaysOff')" (formSubmit)="createDaysOff($event)"></app-holidays-dates-form>
</ng-container>
